import React from 'react'
import styled from 'styled-components'

const AlertsGroupContainer = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  gap: 8px;
  z-index: 1;
`

export const AlertsSection: React.FC<{ className?: string }> = ({
  className,
}) => {
  return <AlertsGroupContainer className={className}></AlertsGroupContainer>
}
